import styled from "styled-components";

const Logo = styled.div`
  align-items: center;
  background: #000;
  color: #f79e19;
  display: flex;
  justify-content: center;
  height: 64px;
`;

const Modalidade = styled.div`
  align-items: center;
  background: #272727;
  display: flex;
  justify-content: center;
  padding: 10px 0;
`;

export { Logo, Modalidade };
